module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is dedicated to my home team: Judy, Clayton and Christine, Karl and Christina, Cara, Elaine and Tessa, Brendan and Christian Kilduff, and Pearl – also to my friend and mentor, the late Clayton Knight, OBE, who was also a friend of Billy Bishop’s.")]), _vm._v(" "), _c('p', {
    staticClass: "fh1"
  }, [_c('b', [_vm._v("Other books by Peter Kilduff")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("The Red Baron")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("That’s My Bloody Plane")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Germany’s Last Knight of the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("U.S. Carriers at War")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("A-4 Skyhawk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Germany’s First Air Force 1914-1918")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Richthofen – Beyond the Legend of the Red Baron")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Over the Battlefronts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("The Red Baron Combat Wing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("The Illustrated Red Baron")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Talking With the Red Baron")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Red Baron – The Life and Death of an Ace")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Black Fokker Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Hermann Göring – Fighter Ace")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Iron Man Rudolf Berthold: Germany’s Indomitable World War I Fighter Ace")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1eb8b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_ded.vue
// module id = 60
// module chunks = 0